import { getBrazeSDK } from '../../Config/Braze/braze.config'
import { BRAZE_EVENTS } from '../../Constants/analytics'
import { executeWithRetry } from '../networking/networkHelpers'

export const logBrazeEvent = async (name: string, params?: any | undefined) => {
  await executeWithRetry(async () => {
    const braze = await getBrazeSDK()
    if (!braze) throw new Error('Braze SDK not available')
    braze.logCustomEvent(name, params)
  }, `log Braze event: ${name}`)
}

export const setBrazeAttribute = async (attributeName: string, property: any) => {
  await executeWithRetry(async () => {
    const braze = await getBrazeSDK()
    if (!braze) throw new Error('Braze SDK not available')
    const brazeUser = braze.getUser()
    if (brazeUser) {
      brazeUser.setCustomUserAttribute(attributeName, property)
    }
  }, `set Braze attribute: ${attributeName}`)
}

export const logBrazePageView = async (
  pageName: string,
  additionalParams?: Record<string, any>
) => {
  await executeWithRetry(async () => {
    const braze = await getBrazeSDK()
    if (!braze) throw new Error('Braze SDK not available')
    const eventName = BRAZE_EVENTS.page_view + pageName
    const eventParams = {
      page_name: pageName,
      ...additionalParams,
    }
    braze.logCustomEvent(eventName, eventParams)
  }, `log Braze page view: ${pageName}`)
}

export const setUserAlias = async (aliasName: string, aliasLabel: string) => {
  await executeWithRetry(async () => {
    const braze = await getBrazeSDK()
    if (!braze) throw new Error('Braze SDK not available')
    const brazeUser = braze.getUser()
    if (brazeUser) {
      brazeUser.addAlias(aliasName, aliasLabel)
    }
  }, `set Braze user alias: ${aliasName}`)
}
